<template>
  <div class="order_evaluate_container">
    <back-header title="评价活动"/>

    <div class="order_title">{{ order.title }}</div>

    <div class="top bg_white">
      <img :src="order.activity_picture_url">
      <div class="intro">描述相符</div>
      <star-rate class="my-star" v-model="star" :allow-clear="false" type="star1"/>
      <span class="starLabel">{{ star | starFilter }}</span>
    </div>

    <mt-field class="f24" placeholder="评价一下该活动" type="textarea" rows="6" v-model="content"/>

    <bottom-btn title="提交" @click.native="submitForm"/>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import StarRate from 'vue-cute-rate'
// https://github.com/luyilin/vue-cute-rate
import backHeader from '@/components/backHeader.vue'
import bottomBtn from '@/components/common/bottomBtn.vue'
import { getOrder, evaluateOrder } from '@/api/order'

export default {
  name: 'order-evaluate',
  props: [],
  data () {
    return {
      star: 5,
      content: '',
      order: {
        id: undefined,
        title: '',
        activity_picture_url: ''
      }
    }
  },
  components: {
    StarRate,
    backHeader,
    bottomBtn
  },
  filters: {
    starFilter (star) {
      let starMap = { 0: '非常差', 1: '非常差', 2: '差', 3: '一般', 4: '好', 5: '非常好' }
      return starMap[star]
    }
  },
  created () {
    let id = this.$route.params.id || 0
    if (!id) {
      this.$router.push('/')
      return false
    }
    this.getOrder(id)
  },
  methods: {
    async getOrder (id) {
      let response = await getOrder(id)
      this.order = response.data
      if (this.order.status !== 3) {
        this.$router.push('/')
        return false
      }
    },
    async submitForm () {
      if (!this.content) {
        Toast({ message: '请填写评价', position: 'middle', duration: 3000 })
        return false
      }

      let data = {
        id: this.order.id,
        score: this.star * 2,
        content: this.content
      }
      await evaluateOrder(data)
      Toast({ message: '提交成功', position: 'middle', duration: 1000 })

      setTimeout(() => {
        this.$router.push('/order/list')
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .mint-cell-wrapper {
    font-size: rem(24);
  }
  .order_evaluate_container {
    color: #333;
    .order_title {
      background: #06c1ae;
      padding: rem(36) rem(18);
      color: #fff;
      font-weight: bold;
      font-size: rem(28);
    }
    .top {
      padding: 5px rem(10);
      height: rem(60);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .my-star {
        margin: 0;
      }
      .starLabel {
        width: rem(100);
        color: #666;
        padding-right: rem(10);
      }
      img {
        width: rem(100);
      }
    }
  }
</style>
